import React from "react";
import Loader from "react-loader-spinner";

export default () => (
    <div className="loader-container">
        <Loader type="Puff" color="#00BFFF" height="50" width="50"/>
    </div>
);
